import { ReactElement } from "react";
import ConnectionPage from "./ConnectionPage";
import { useAppSelector } from "../../redux/store";

interface ConnectionProps {
  children: ReactElement
}

export default function Connection({ children }: ConnectionProps) {
  const token = useAppSelector(state => state.appState.token);

  return !token ?
    <ConnectionPage />
    : children;
}